<form *ngIf="loginForm" [formGroup]="loginForm" style="max-width: 400px">
	<h2 mat-dialog-title fxLayout="row">
		<span fxFlex style="position: relative; top: 3px; left: 5px;">User Management - Setup</span>
		<button (click)="close()" tabindex="-1" mat-icon-button>
			<mat-icon>close</mat-icon>
		</button>
	</h2>
	<mat-dialog-content>
		<div fxLayout="column">
			<h3>
				Authentication method
			</h3>
			<mat-radio-group formControlName="method" fxLayout="column">
				<mat-radio-button value="token">Token based authentication (mobile ready)</mat-radio-button>
				<mat-radio-button value="session">Session based authentication</mat-radio-button>
			</mat-radio-group>
			
			<h3>
				<mat-checkbox formControlName="user_profile_enabled">User profile</mat-checkbox>
			</h3>
			<mat-form-field *ngIf="entities?.length > 0; else noEntities">
				<mat-select placeholder="Select the user profile entity" formControlName="user_profile_entity">
					<mat-option *ngFor="let entity of entities" [value]="entity.name">{{ entity.name }}</mat-option>
				</mat-select>
			</mat-form-field>
			<ng-template #noEntities>
				<div class="warning">
					No entity found. You need an entity to add custom fields to your users.
				</div>
			</ng-template>
		
			<h3>
				<mat-checkbox formControlName="email_verification">Emails enabled</mat-checkbox>
			</h3>

			<mat-form-field *ngIf="emailAddons && emailAddons.length > 0; else noEmailAddon">
				<mat-select placeholder="Select your emailing addon" formControlName="email_addon">
					<mat-option *ngFor="let addon of emailAddons" [value]="addon.package">{{ addon.name }}</mat-option>
				</mat-select>
			</mat-form-field>

			<ng-template #noEmailAddon>
				<div class="warning">You need
					<strong>Mailjet</strong> addon installed
					<br>to send email from your Materia Application such as a signup email</div>
			</ng-template>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions>
		<button mat-raised-button color="primary" (click)="finish()">Save</button>
		<button mat-raised-button (click)="close()">Cancel</button>
	</mat-dialog-actions>
</form>